/**
 * Common utility methods shared by extensions and embedding
 */
export namespace ApiUtils {
  export type CommandResult = { [docParamId: string]: object };

  /**
   * @param error -  an error wrapped in an error object from server, the error string from server, or a InternalTableauError
   */
  // tslint:disable-next-line:no-any
  export function getErrorMessageFromException(error: any): string {
    if (error === undefined) {
      return 'Unknown Error';
    }

    // check if we have a simple string
    if (typeof error === 'string') {
      return error;
    }

    // check for InternalTableauError
    if (error.message !== undefined) {
      return error.message;
    }

    if (typeof error.get_message === 'function') {
      // If the error message contains "TableauException:", get that part and return it.
      // Otherwise return the original error message.
      const errorString = error.get_message();
      let exceptionMessage = errorString;
      const startStr = 'TableauException:';
      if (errorString.includes(startStr)) {
        exceptionMessage = errorString.substring(errorString.indexOf(startStr));
        let endStr = '<br>';
        if (!exceptionMessage.includes(endStr)) {
          endStr = '\n';
        }
        exceptionMessage = exceptionMessage.substring(0, exceptionMessage.indexOf(endStr) - 1);
      }
      return exceptionMessage;
    }

    return error;
  }
}
